import { useEffect, useState } from 'react';

export const useGoogleMapsLoader = (apiKey, libraries = ['places']) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const librariesParam = Array.isArray(libraries) ? libraries.join(',') : String(libraries || '');

  useEffect(() => {
    if (!apiKey) return;
    if (window.google && window.google.maps) {
      setIsLoaded(true);
      return;
    }

    const scriptId = 'google-maps-script';
    const existing = document.getElementById(scriptId);

    if (existing) {
      const onLoad = () => setIsLoaded(true);
      existing.addEventListener('load', onLoad);
      return () => existing.removeEventListener('load', onLoad);
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${librariesParam}&loading=async&v=weekly`;
    script.async = true;
    script.defer = true;
    script.onload = () => setIsLoaded(true);
    script.onerror = () => setIsLoaded(false);
    document.head.appendChild(script);
  }, [apiKey, librariesParam]);

  return { isLoaded };
};
